<template>
  <q-layout view="hHh lpR lFr">
    <q-header elevated class="bg-primary text-white">
      <q-toolbar>
        <q-btn v-if="false && isLoggedIn" dense flat round icon="menu"/>

        <q-toolbar-title @click="logoClicked">
          <q-icon name="lock"/>
          SocialWolvez
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-drawer
        :width="250"
        :model-value="isDrawerOpen"
        behavior="desktop"
        side="left"
        bordered
    >
      <!-- drawer content -->
      <q-scroll-area class="fit">
        <q-list>
          <template v-for="(menuItem, index) in menuItems" :key="index">
            <q-item
                @click="menuItem.onClick"
                clickable
                :active="menuItem.label === 'Outbox'"
                v-ripple
            >
              <q-item-section v-if="authStore.isLoggedIn" avatar>
                <q-icon :name="menuItem.icon"/>
              </q-item-section>
              <q-item-section>
                {{ menuItem.label }}
              </q-item-section>
            </q-item>
            <q-separator :key="'sep' + index" v-if="menuItem.separator"/>
          </template>
        </q-list>
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="routeKey" />
      </router-view>
    </q-page-container>
  </q-layout>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import {PagesEnum} from "@/router";
import {useAuthStore} from "@/stores/auth.store";
import {SOCIAL_WOLVES_HOME} from "@/utils/contants";

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();
const isLoggedIn = authStore.isLoggedIn;

// If we're editing a link, and then creating, we'll see cached content,
// so we're forcing rerender.
const routeKey = computed<string>(() => {
  return route.fullPath;
});

const isDrawerOpen = computed<boolean>(() => {
  const isLoggedIn = authStore.isLoggedIn
  // Even if logged in do not appear in Display Link
  const isDisplayingLink = route.name == PagesEnum.LINK_DISPLAY
  return isLoggedIn && !isDisplayingLink;
})

const menuItems = [
  {
    label: "Links",
    value: "links",
    icon: "link",
    separator: true,
    onClick: async () => {
      await router.push({name: PagesEnum.DASHBOARD})
    },
  },
  {
    label: "Log out",
    value: "logout",
    icon: "logout",
    separator: false,
    onClick: async () => {
      await authStore.logout();
    },
  },
];

function logoClicked() {
  window.location.href = '/'
}
</script>
